export default "__VITE_ASSET__BWKaiEC3__"